module.exports = __webpack_public_path__ + "img/head_bg.90105b08.png";